// media

const archival = 'Archival pigment print'
const ink = 'Ink on paper'

// sizes

const sizeOne = '60 x 100 in, 152.4 x 254 cm'
const sizeTwo = '25 x 40 in, 63.5 x 101.6 cm'
const sizesOne = [sizeOne, sizeTwo]
const sizeThree = '100 x 60 in, 254 x 152.4 cm'
const sizeFour = '25 x 40 in, 101.6 x 63.5 cm'
const sizesTwo = [sizeThree, sizeFour]
const sizeFive = '36 x 24 in'
const sizeSix = '91.4 x 60.9 cm'
const sizesThree = [sizeFive, sizeSix]
const sizeSeven = '24 x 24 in'
const sizeEight = '60.9 x 60.9 cm'
const sizesFour = [sizeSeven, sizeEight]
const sizeNine = '24 x 36 in'
const sizeTen = '60.8 x 91.4 x 60.9 cm'
const sizesFive = [sizeNine, sizeTen]

// editions

const editionOne = 'Edition of 3 + 2 APs'
const editionTwo = 'Edition of 30 + 2 APs'

// collections 

const collections = [
  {
    title: 'AI Meditations lead by The WarNymph',
    shortTitle: 'AI Meditations',
    route: 'ai-meditations-lead-by-the-war-nymph',
    id: 0,
    description: 'As part of the central A/V installation, the WarNymph AI Meditations reflect the digital realm and are a lot more effective for those of us who’ve grown up as Cyborgs, attached to our phones. Grimes has developed a meditation series - written and performed entirely by an Artificial Intelligence Entity.',
    shopLink: 'mailto:michele@maccarone.net',
    pieces: [
      {
        title: 'AI Meditations led by The WarNymph',
        date: '2020',
        medium: 'Site-specific audio/video installation',
        edition: '',
        description: 'As part of the central A/V installation, the WarNymph AI Meditations reflect the digital realm and are a lot more effective for those of us who’ve grown up as Cyborgs, attached to our phones. The artist has developed a meditation series - written and performed entirely by an Artificial Intelligence Entity.',
        sizes: [''],
        images: {
          full: [
            require('./assets/AI Meditations/ai-1.png'),
            require('./assets/AI Meditations/ai-2.png'),
            require('./assets/AI Meditations/ai-3.png'),
            require('./assets/AI Meditations/ai-4.png'),
            require('./assets/AI Meditations/ai-5.png')
          ],
          square: [
            require('./assets/AI Meditations/ai-1-sq.png'),
            require('./assets/AI Meditations/ai-2-sq.png'),
            require('./assets/AI Meditations/ai-3-sq.png'),
            require('./assets/AI Meditations/ai-4-sq.png'),
            require('./assets/AI Meditations/ai-5-sq.png')
          ]
        },
        video: {
          url: 'https://www.youtube.com/embed/3ai-_sqJF-Y',
          description: 'AI Meditations'
        },
        // audio: require(''),
        saleStatus: 'Inquire for Purchase'
      }
    ]
  },
  {
    title: 'The WarNymph: Scenes',
    route: 'the-war-nymph-scenes', // page will live at site/collections/war-nymph
    id: 1,
    description: 'Selling Out explores the notion of identity potential in the digital age: the ability to create, augment, and manifest ourselves outside of our biological limits. Grimes does so with WarNymph, a digital AI avatar executed in collaboration with her brother and artistic partner, Mac Boucher.',
    shopLink: 'https://www.maccaroneshop.net/collections/warnymph-photographs',
    pieces: [
      {
        title: 'WarNymph Prototype #1: Battle of the WarNymphs',
        date: '2020',
        medium: archival,
        edition: editionOne,
        sizes: sizesOne,
        images: {
          full: [
            require('./assets/WarNymph/battle01.png'),
            require('./assets/WarNymph/battle02.png'),
            require('./assets/WarNymph/battle03.png'),
            require('./assets/WarNymph/battle04.png'),
            require('./assets/WarNymph/battle05.png'),
            require('./assets/WarNymph/battle06.png'),
            
          ],
          square: [
            require('./assets/WarNymph/battle01-sq.png'),
            require('./assets/WarNymph/battle02-sq.png'),
            require('./assets/WarNymph/battle03-sq.png'),
            require('./assets/WarNymph/battle04-sq.png'),
            require('./assets/WarNymph/battle05-sq.png'),
            require('./assets/WarNymph/battle06-sq.png'),
            
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase',
      },
      {
        title: 'WarNymph Prototype #4: Couture raving.exe',
        date: '2020',
        medium: archival,
        edition: editionOne,
        sizes: sizesOne,
        images: {
          full: [
            require('./assets/WarNymph/couture01.png'),
            require('./assets/WarNymph/couture02.png'),
            require('./assets/WarNymph/couture03.png'),
            require('./assets/WarNymph/couture04.png'),
            require('./assets/WarNymph/couture05.png'),
            require('./assets/WarNymph/couture06.png'),
          ],
          square: [
            require('./assets/WarNymph/couture01-sq.png'),
            require('./assets/WarNymph/couture02-sq.png'),
            require('./assets/WarNymph/couture03-sq.png'),
            require('./assets/WarNymph/couture04-sq.png'),
            require('./assets/WarNymph/couture05-sq.png'),
            require('./assets/WarNymph/couture06-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'WarNymph Prototype #2: Tyrant',
        date: '2020',
        medium: archival,
        edition: editionOne,
        sizes: sizesOne,
        images: {
          full: [
            require('./assets/WarNymph/tyrant01.png'),
            require('./assets/WarNymph/tyrant02.png'),
            require('./assets/WarNymph/tyrant03.png'),
            require('./assets/WarNymph/tyrant04.png'),
            require('./assets/WarNymph/tyrant05.png'),
            require('./assets/WarNymph/tyrant06.png'),
          ],
          square: [
            require('./assets/WarNymph/tyrant01-sq.png'),
            require('./assets/WarNymph/tyrant02-sq.png'),
            require('./assets/WarNymph/tyrant03-sq.png'),
            require('./assets/WarNymph/tyrant04-sq.png'),
            require('./assets/WarNymph/tyrant05-sq.png'),
            require('./assets/WarNymph/tyrant06-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'WarNymph Prototype #5: Pigly Thee Familiar',
        date: '2020',
        medium: archival,
        edition: editionOne,
        sizes: sizesOne,
        images: {
          full: [
            require('./assets/WarNymph/pigly01.png'),
            require('./assets/WarNymph/pigly02.png'),
            require('./assets/WarNymph/pigly03.png'),
            require('./assets/WarNymph/pigly04.png'),
            require('./assets/WarNymph/pigly05.png'),
          ],
          square: [
            require('./assets/WarNymph/pigly01-sq.png'),
            require('./assets/WarNymph/pigly02-sq.png'),
            require('./assets/WarNymph/pigly03-sq.png'),
            require('./assets/WarNymph/pigly04-sq.png'),
            require('./assets/WarNymph/pigly05-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'WarNymph Prototype #3: WarMachine',
        date: '2020',
        medium: archival,
        edition: editionOne,
        sizes: sizesTwo,
        tall: true,
        images: {
          full: [
            require('./assets/WarNymph/machine01.png'),
            require('./assets/WarNymph/machine02.png'),
            require('./assets/WarNymph/machine03.png'),
            require('./assets/WarNymph/machine04.png'),
            require('./assets/WarNymph/machine05.png'),
          ],
          square: [
            require('./assets/WarNymph/machine01-sq.png'),
            require('./assets/WarNymph/machine02-sq.png'),
            require('./assets/WarNymph/machine03-sq.png'),
            require('./assets/WarNymph/machine04-sq.png'),
            require('./assets/WarNymph/machine05-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
    ]
  },
  {
    title: 'Miss Anthropocene: failed album covers',
    shortTitle: 'Miss Anthropocene',
    route: 'miss-anthropocene-failed-album-covers',
    id: 2,
    description: 'The digitally rendered artworks depict images that were ultimately not used as the Miss Anthropocene cover. They are executed with the same sense of authority as if they were drawn by hand with the intention of representing the album. They express a creative vulnerability in exposing the artists’ process and authenticity.',
    shopLink: 'https://www.maccaroneshop.net/collections/miss-anthropocene',
    pieces: [
      {
        title: 'birthday card',
        date: '2019/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesThree,
        tall: true,
        images: {
          full: [
            require('./assets/Miss Anthropocene/ma-1.png'),
          ],
          square: [
            require('./assets/Miss Anthropocene/ma-1-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'Pigly',
        date: '2019/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        images: {
          full: [
            require('./assets/Miss Anthropocene/ma-2.png'),
          ],
          square: [
            require('./assets/Miss Anthropocene/ma-2-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'i wanted a puppy',
        date: '2019/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesThree,
        tall: true,
        images: {
          full:[
            require('./assets/Miss Anthropocene/ma-3.png'),
          ],
          square: [
            require('./assets/Miss Anthropocene/ma-3-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'This story is dedicated to all those cyberpunks who fight corruption & injustice every day of their lives: Excercises In Nightcore by Grimes',
        date: '2019/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        images: {
          full: [
            require('./assets/Miss Anthropocene/ma-4.png'),
          ],
          square: [
            require('./assets/Miss Anthropocene/ma-4-sq.png'),
          ],
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'ГРАЙМC',
        date: '2019/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        images: { 
          full: [
            require('./assets/Miss Anthropocene/ma-5.png'),
          ],
          square: [
            require('./assets/Miss Anthropocene/ma-5-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: `failed album cover 1 (Miss Anthropocene)`,
        date: '2019/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFive,
        images: {
          full: [
            require('./assets/Miss Anthropocene/ma-6.png'),
          ],
          square: [
            require('./assets/Miss Anthropocene/ma-6-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'square',
        date: '2019/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        images: {
          full: [
            require('./assets/Miss Anthropocene/ma-7.png'),
          ],
          square: [
            require('./assets/Miss Anthropocene/ma-7-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'failed album cover 2',
        date: '2019/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        images: {
          full: [
            require('./assets/Miss Anthropocene/ma-8.png'),
          ],
          square: [
            require('./assets/Miss Anthropocene/ma-8-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'Seldon Crisis',
        date: '2016/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFive,
        images: {
          full: [
            require('./assets/Miss Anthropocene/ma-9.png'),
          ],
          square: [
            require('./assets/Miss Anthropocene/ma-9-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
    ]
  },
  {
    title: 'A discography; in paintings',
    route: 'a-discography-in-paintings',
    id: 3,
    description: 'The five album covers, represent the decade of Grimes with her ability to actualize a cerebral concept into physical reality. The art affirms her interdisciplinary practice by visually articulating her music resulting in an innate audiovisual experimentation.',
    shopLink: 'https://www.maccaroneshop.net/collections/album-cover-prints',
    pieces: [
      {
        title: 'i: Geidi primes',
        date: '2010/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        square: true,
        images: {
          full: [
            require('./assets/Decade of Grimes/dg-1.png'),
          ],
          square: [
            require('./assets/Decade of Grimes/dg-1.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'ii: Halfaxa',
        date: '2010/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        square: true,
        images: {
          full: [
            require('./assets/Decade of Grimes/dg-2.png'),
          ],
          square: [
            require('./assets/Decade of Grimes/dg-2.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'iii: Visions',
        date: '2012/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        square: true,
        images: {
          full: [
            require('./assets/Decade of Grimes/dg-3.png'),
          ],
          square: [
            require('./assets/Decade of Grimes/dg-3.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'iv: Art Angels',
        date: '2015/2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        square: true,
        images: {
          full: [
            require('./assets/Decade of Grimes/dg-4.png'),
          ],
          square: [
            require('./assets/Decade of Grimes/dg-4.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'v: Miss Anthropocene',
        date: '2020',
        medium: archival,
        edition: editionTwo,
        sizes: sizesFour,
        square: true,
        images: {
          full: [
            require('./assets/Decade of Grimes/dg-5.png'),
          ],
          square: [
            require('./assets/Decade of Grimes/dg-5.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
    ]
  },
  {
    title: 'Early rarities',
    route: 'early-rarities',
    id: 4,
    description: 'The selection of early rarities reveal the origin of Grimes’ visual language. These drawings filled diaristic notebooks with mythic and psychedelic imagery, borrowing from Art Nouveau, Aztec, and surrealist iconographies.',
    shopLink: 'https://www.maccaroneshop.net/collections/original-drawings',
    pieces: [
      {
        title: 'Untitled (notebook drawing #1)',
        date: '2006-2008',
        medium: ink,
        edition: '',
        sizes: ['8.5 x 11 in', '21.6 x 27.9 cm'],
        tall: true,
        images: {
          full: [
            require('./assets/Early Years/ey-1.png'),
          ],
          square: [
            require('./assets/Early Years/ey-1-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'Untitled (notebook drawing #2)',
        date: '2006-2008',
        medium: ink,
        edition: '',
        sizes: ['9 x 12 in', '22.9 x 30.5 cm'],
        tall: true,
        images: {
          full: [
            require('./assets/Early Years/ey-2.png'),
          ],
          square: [
            require('./assets/Early Years/ey-2-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'Untitled (notebook drawing #3)',
        date: '2006-2008',
        medium: ink,
        edition: '',
        sizes: ['9 x 11 in', '22.9 x 27.9 cm'],
        tall: true,
        images: {
          full: [
            require('./assets/Early Years/ey-3.png'),
          ],
          square: [
            require('./assets/Early Years/ey-3-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'Untitled (notebook drawing #4)',
        date: '2006-2008',
        medium: ink,
        edition: '',
        sizes: ['8 x 10.75 in', '20.3 x 27.3 cm'],
        tall: true,
        images: {
          full: [
            require('./assets/Early Years/ey-4.png'),
          ],
          square: [
            require('./assets/Early Years/ey-4-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'Untitled (notebook drawing #5)',
        date: '2006-2008',
        medium: ink,
        edition: '',
        sizes: ['8 x 11 in', '20.3 x 27.9 cm'],
        tall: true,
        images: {
          full: [
            require('./assets/Early Years/ey-5.png'),
          ],
          square: [
            require('./assets/Early Years/ey-5-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'Untitled (notebook drawing #6)',
        date: '2006-2008',
        medium: ink,
        edition: '',
        sizes: ['8.5 x 11 in', '21.6 x 27.9 cm'],
        images: {
          full: [
            require('./assets/Early Years/ey-6.png'),
          ],
          square: [
            require('./assets/Early Years/ey-6-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'Untitled (notebook drawing #7)',
        date: '2006-2008',
        medium: ink,
        edition: '',
        sizes: ['9 x 11 in', '22.9 x 27.9 cm'],
        tall: true,
        images: {
          full: [
            require('./assets/Early Years/ey-7.png'),
          ],
          square: [
            require('./assets/Early Years/ey-7-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
      {
        title: 'Untitled (notebook drawing #8)',
        date: '2006-2008',
        medium: ink,
        edition: '',
        sizes: ['8 x 11 in', '21.6 x 27.9 cm'],
        images: {
          full: [
            require('./assets/Early Years/ey-8.png'),
          ],
          square: [
            require('./assets/Early Years/ey-8-sq.png'),
          ]
        },
        // audio: require(''),
        shopLink: '',
        saleStatus: 'Purchase'
      },
    ]
  },
  {
    title: 'Selling Out',
    route: 'selling-out',
    id: 5,
    description: 'Selling Out​ is executed as a contract in which Grimes sells a fraction of her soul, formalizing the idea that every time an artist sells a piece of their art, part of the soul is sold with it. The purchaser will enter into a contractual agreement that outlines the terms of ownership and ultimately the connection to the joy of artistic expression.',
    shopLink: 'mailto:michele@maccarone.net',
    pieces: [
      {
        title: 'Selling Out',
        date: '2020',
        description: 'Selling Out​ is executed as a contract in which Grimes sells a fraction of her soul, formalizing the idea that every time an artist sells a piece of their art, part of the soul is sold with it. The purchaser will enter into a contractual agreement that outlines the terms of ownership and ultimately the connection to the joy of artistic expression.',
        medium: '',
        edition: '',
        sizes: [''],
        tall: true,
        pdf: require('../pdf/contract.pdf'),
        images: {
          full: [
            require('./assets/Selling Out/so-1.png'),
            require('./assets/Selling Out/so-2.png'),
            require('./assets/Selling Out/so-3.png')
          ],
          square: [
            require('./assets/Selling Out/so-1-sq.png'),
            require('./assets/Selling Out/so-2-sq.png'),
            require('./assets/Selling Out/so-3-sq.png'),
          ]
        },
        shopLink: '',
        saleStatus: 'Inquire To Make An Offer'
      }
    ]
  },
]

export default collections
